import type { FaqItem } from "../../../@types/portalAluno";

export const FAQ_ITEMS: FaqItem[] = [
  {
    id: 1,
    question: "Não encontrei um curso ou conteúdo específico. O que devo fazer?",
    answer:
      "Confirme se o conteúdo é compatível com o seu perfil e use a pesquisa no topo da página. Você também pode navegar pelas categorias da Home. Se ainda houver divergência, envie uma mensagem pelo Fale Conosco.",
  },
  {
    id: 2,
    question: "O que é a Biblioteca?",
    answer:
      "A Biblioteca reúne materiais úteis para o dia a dia, como vídeos, podcasts, artigos, documentos e conteúdos de Simuladores & Games. Você pode acessá-los quando precisar.",
  },
  {
    id: 3,
    question: "O que são os destaques da tela inicial?",
    answer:
      "Os destaques são conteúdos importantes que estão em evidência. Eles ficam na Home para oferecer acesso rápido ao material relacionado.",
  },
  {
    id: 4,
    question: "Como vejo os conteúdos e atividades que já realizei?",
    answer:
      "Abra o Menu e selecione Histórico. Os conteúdos acessados aparecem com a data do último acesso e podem ser abertos novamente.",
  },
  {
    id: 5,
    question: "O que são as notificações?",
    answer:
      "As notificações avisam quando novos conteúdos ficam disponíveis para o seu perfil. Elas são organizadas por categoria para facilitar a consulta.",
  },
  {
    id: 6,
    question: "Como resolvo um problema de acesso?",
    answer:
      "O acesso ao portal usa a autenticação corporativa. Em caso de bloqueio, senha expirada ou usuário não autorizado, procure o suporte responsável pela sua credencial.",
  },
  {
    id: 7,
    question: "Quais dispositivos são compatíveis com o Conectado?",
    answer:
      "O portal funciona nos navegadores modernos de computadores, tablets e celulares. Para a melhor experiência, mantenha o navegador atualizado.",
  },
  {
    id: 8,
    question: "Preciso estar online para usar o Conectado?",
    answer:
      "Sim. Os conteúdos, seu progresso e as atualizações são carregados em tempo real, por isso é necessária uma conexão com a internet.",
  },
  {
    id: 9,
    question: "Quem pode utilizar o Conectado?",
    answer:
      "O Conectado é destinado às pessoas previamente cadastradas pela área responsável. A disponibilidade de cada conteúdo depende do perfil e da cidade associados ao usuário.",
  },
  {
    id: 10,
    question: "O que é o item Favoritos?",
    answer:
      "Ao marcar um conteúdo como favorito, ele passa a aparecer na área Favoritos. Para removê-lo, abra o conteúdo e desmarque a opção de favorito.",
  },
  {
    id: 11,
    question: "O que é o item Notificações do Menu?",
    answer:
      "É a área que reúne os novos conteúdos disponibilizados para você, separados entre conteúdos, cursos, comunicados, trilhas e outras categorias.",
  },
  {
    id: 12,
    question: "O que é o item Enquetes e Pesquisas?",
    answer:
      "Essa área reúne avaliações internas e pesquisas externas usadas para mapear oportunidades de treinamento, comunicação e melhoria da experiência.",
  },
  {
    id: 13,
    question: "O que é o item Meus Dados?",
    answer:
      "Meus Dados apresenta as informações vinculadas ao seu cadastro. Você pode atualizar o e-mail e informar divergências pelo atalho para o suporte.",
  },
  {
    id: 14,
    question: "O que é o item Fale Conosco?",
    answer:
      "É o canal para enviar dúvidas, sugestões e solicitações ao time de treinamento. O retorno será enviado ao e-mail cadastrado.",
  },
];
